import { Component, ViewEncapsulation } from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';
import { BaseComponent } from '../base.component';

@Component({
    selector: 'ig-row-action-buttons',
    templateUrl: './row.action.buttons.component.html',
    styleUrls: ['./row.action.buttons.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RowActionButtonsComponent extends BaseComponent {
    public isLoading: boolean;

    constructor() {
        super();
        bindFunctionsToThis(this);
    }

    public onClick($event) {
        if (this.isLoading) {
            $event.stopPropagation();
            $event.preventDefault();
        }
    }

    public startLoading() {
        this.isLoading = true;
    }

    public stopLoading() {
        this.isLoading = false;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/row.action.buttons/row.action.buttons.component.ts